import React from 'react'
// import { FieldContract } from '../Common/FieldsForForms'
import { LinearLoading } from 'common'
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, IconButton, TextField, Typography } from '@mui/material'
import { CustomAutocomplete } from 'common'
import { FieldContract, InfoContract } from '../Common'
import { FileManagerInput } from 'common'
import { CheckCircle, Download, Plus, Trash2, UploadCloud, XCircle } from 'react-feather'
import { DepositTable } from './GSPRemovalSection/DepositTable'

const acceptConfiguration = {
    'application/pdf': []
}

export const TerminationCreditLegal = ({ useFetchInit }) => {
    const { 
        //------------- Generales
        location,
        paramsURL,
        //------------- globalStates
        globalStates,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions,
        //------------- helpers
        Helpers,
        //------------- Formularios
        Forms
        
    } = useFetchInit

        // ------------------------------------------------ Formularios
        const { FormRequestGlobal } = Forms
        const { 
            formState, 
            onInputChange, 
            onInputChangeForNumber,
            onDropZoneAcceptedFilesChange, 
            onDropZoneRejectionsFilesChange, 
        } = FormRequestGlobal

        const { formOpeningMode} = globalStates

        //------------------------------------------------- Fech data

        //------------------------------------------------- Actions
        const {handleClickShowModal, onSubmitFormFiles} = Actions

    return (
        <>
            <Typography sx={{mt:3,fontWeight: 'bold'}} variant='subtitle2'>
                Informacion sobre la gestion
            </Typography>
            <div className="border-bottom border-dark"></div>
            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mb: 1, mt: 2}}>
                <Grid item xs={12} sm={12} md={4} lg={4} >
                    <FormControl fullWidth>
                        <label htmlFor="fecha_finalizacion">Fecha de finalizacion del Credito</label>
                        <TextField
                            id='fecha_finalizacion'
                            name='fecha_finalizacion'
                            value={ formState.fecha_finalizacion }  
                            onChange={ onInputChange }
                            size='small'
                            placeholder='fecha_finalizacion'
                            type='date'
                            variant='filled'
                            InputProps={{
                                readOnly: true 
                            }}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                        <label htmlFor="suma_dias_atraso_totales">Total dias de atraso</label>
                        <TextField
                            id='suma_dias_atraso_totales'
                            name='suma_dias_atraso_totales'
                            value={ formState.suma_dias_atraso_totales }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Día de registro'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>
                        
                <Grid item xs={12} sm={12} md={4} lg={4}>
                    <FormControl fullWidth>
                    <label htmlFor="saldo_financiar">Monto del Credito (Q)</label>
                    <TextField
                        id='saldo_financiar'
                        name='saldo_financiar'
                        value={ formState.saldo_financiar }
                        onChange={ onInputChange }
                        size='small'
                        placeholder='Monto a Financiar'
                        type='text'
                        variant='filled'
                        InputProps={{
                            readOnly: true
                        }}
                        required
                    />
                    </FormControl>
                </Grid>



                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="suma_total_pagar">Deuda Restante del Credito (Q)</label>
                        <TextField
                            id='suma_total_pagar'
                            name='suma_total_pagar'
                            value={ formState.suma_total_pagar }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deuda Restante del Credito'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                
                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_gastos_juridicos">Deuda Gastos Juridicos (Q)</label>
                        <TextField
                            id='total_gastos_juridicos'
                            name='total_gastos_juridicos'
                            value={ formState.total_gastos_juridicos }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deuda Gastos Juridicos'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_gastos_admin">Deuda Gastos Administrativos (Q)</label>
                        <TextField
                            id='total_gastos_admin'
                            name='total_gastos_admin'
                            value={ formState.total_gastos_admin }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Deuda Gastos Juridicos'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                <Grid item xs={12} sm={12} md={4} lg={4} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="costo_finiquito">Costo de Finiquito (Q)</label>
                        <TextField
                            id='costo_finiquito'
                            name='costo_finiquito'
                            value={ formState.costo_finiquito }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Costo de Finiquito'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>

                 <Grid item xs={12} sm={12} md={8} lg={8} sx={{mb: 1, mt: 3}}>
                    <FormControl fullWidth>
                        <label htmlFor="total_deuda_credito">Total Deuda (Q)</label>
                        <TextField
                            id='total_deuda_credito'
                            name='total_deuda_credito'
                            value={ formState.total_deuda_credito }
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Total Deuda'
                            type='text'
                            variant={'filled'}
                            InputProps={{readOnly: true}}
                            required
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 3 }}>
                    <FormControl fullWidth>
                        <label htmlFor="total_negociado">Total negociado (Q)</label>
                        <TextField
                            id='total_negociado'
                            name='total_negociado'
                            value={ formState.total_negociado } 
                            onChange={ onInputChangeForNumber }
                            size='small'
                            placeholder='total_negociado'
                            type='text'
                            variant= {(formOpeningMode==='READONLY')? 'filled' : 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY')? true : false
                            }}
                            
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6} sx={{ mb: 1, mt: 3, }}>
                    <FormControl fullWidth>
                        <label htmlFor="butto_payment">Pago</label>
                        <Button
                            startIcon={<Plus/>}
                            variant='contained'
                            sx={{marginBottom: 4}} 
                            color='primary' 
                            onClick={()=>handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'EDITABLE')}
                            disabled={(formOpeningMode==='READONLY')? true : false}
                        >
                            Agregar Pago
                        </Button>
                    </FormControl>
                </Grid>
                
                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                
                  <FormControl fullWidth>
                    <label htmlFor="tabla_depositos">Tabla de pagos</label>
                    <DepositTable useFetchInit={useFetchInit}/>
                  </FormControl>
                
                </Grid>

                <Grid item xs={12} sm={12} md={12} lg={12} sx={{ mb: 1, mt: 2 }}>
                    <FormControl fullWidth>
                        <label htmlFor="gestion_descripcion">Descripcion</label>
                        <TextField
                            id='gestion_descripcion'
                            name='gestion_descripcion'
                            value={ formState.gestion_descripcion } 
                            onChange={ onInputChange }
                            size='small'
                            placeholder='Descripcion'
                            type='text'
                            multiline
                            rows={5}
                            variant={(formOpeningMode==='READONLY')? 'filled': 'outlined'}
                            InputProps={{
                                readOnly: (formOpeningMode==='READONLY') ? true: false 
                            }}
                            
                        />
                    </FormControl>
                </Grid>
            </Grid>
        </>
    )
}
